import { GiftOrderGiftRow, GiftOrderResultResponse } from '@models/gift';
import dayjs from 'dayjs';

export type SentOrderUiStatus = 'PAID' | 'USED' | 'CANCELLED';

export function getSentOrderUiStatus(status: GiftOrderResultResponse['status']): SentOrderUiStatus {
    if (status === 'FULL_CANCELLED' || status === 'PARTIAL_CANCELLED') return 'CANCELLED';
    if (status === 'USED') return 'USED';
    return 'PAID';
}

export function canCancelGiftOrder(order: GiftOrderResultResponse): boolean {
    if (getSentOrderUiStatus(order.status) !== 'PAID') return false;
    if (!order.cancelableAt) return false;
    if (!order.recipients.every((recipient) => recipient.gifts.every((gift) => gift.status === 'ISSUED'))) return false;
    return dayjs(order.cancelableAt).isAfter(dayjs());
}

export function formatPhoneNo(phoneNo: string): string {
    const digits = phoneNo.replace(/\D/g, '');
    if (digits.length === 11) {
        return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
    }
    if (digits.length === 10) {
        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return phoneNo;
}

export function formatDateTime(value?: Date | string): string {
    if (!value) return '-';
    return dayjs(value).format('YYYY.MM.DD HH:mm');
}

export function getRecipientGiftLabel(
    gift: GiftOrderGiftRow | undefined,
    labels: {
        beforeUse: string;
        used: string;
        expired: string;
        canceled: string;
        deleted: string;
    },
): string {
    if (!gift) return '-';
    switch (gift.status) {
    case 'ISSUED':
        return labels.beforeUse;
    case 'USED':
        return gift.usedAt
            ? `${formatDateTime(gift.usedAt)} ${labels.used}`
            : labels.used;
    case 'EXPIRED':
        return labels.expired;
    case 'CANCELED':
        return labels.canceled;
    case 'DELETED':
        return labels.deleted;
    default:
        return '-';
    }
}

export function getOrderUsedAt(order: GiftOrderResultResponse): string | undefined {
    const used = order.recipients
        .flatMap((r) => r.gifts)
        .find((g) => g.status === 'USED' && g.usedAt);
    return used?.usedAt ? String(used.usedAt) : undefined;
}
